<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Variables</h1>
          <p>Create global variables and link them to any property across any layer. Experiment with your designs, keep organized, and unlock new functionality within Figma.</p>
          <br><p>Originally released July 2021</p>
          <br><p>Visit the <a href="https://www.figma.com/community/plugin/1000963812142874727/variables" target="_blank">plugin page</a>.</p>
          <!-- <p>While building out certain projects in Figma, I found myself wishing I could link certain properties across layers beyond the native color and font styles. I wanted to experiment with different corner radiuses across all my components, set a global direction for all my drop shadows, set the width of one layer to be twice the width of another layer. I realized that Figma, as fully featured and intuitive as it is, was missing functionality that comes second nature to many designers and developers: variables. I figured there had to be some plugin out there that could solve my woes.<br/>Spoiler alert: there wasn’t.</p> -->
          <!-- <p>Existing plugins could tackle a couple of my issues here and there, but there was nothing on the market that could do everything I was looking for. So I set out to build it myself. I started by spending time reading through Figma’s plugin API documentation, studying the plugins I used, and building my own demo plugins. From there, I mapped out exactly which problems I wanted Variables to solve and came up with a plan for how to solve them. The last step was to come up with an efficient design so that users would be able to create/edit variables, link variables to layer properties, and tweak plugin behavior with ease.</p> -->
        </project-text>

        <project-carousel
        size="75"
        :color="$store.state.activeProject.color"
        :autoplay="false">
          <slide><img v-lazy="'/img/p/figmaplugins/variables1.jpg'" alt="Screenshot of the Variables plugin"></slide>
          <slide><img v-lazy="'/img/p/figmaplugins/variables2.jpg'" alt="Screenshot of the Variables plugin"></slide>
        </project-carousel>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Populate</h1>
          <p>Effortlessly link your text and image layers with 130+ properties across 20+ unique categories. Then with one click, populate your designs with authentic, detailed data.</p>
          <br><p>Originally released May 2023</p>
          <br><p>Visit the <a href="https://www.figma.com/community/plugin/1240181312791888696/Populate" target="_blank">plugin page</a>.</p>
        </project-text>

        <project-carousel
        size="75"
        :color="$store.state.activeProject.color"
        :autoplay="false">
          <slide><img v-lazy="'/img/p/figmaplugins/populate1.jpg'" alt="Screenshot of the Populate plugin"></slide>
          <slide><img v-lazy="'/img/p/figmaplugins/populate2.jpg'" alt="Screenshot of the Populate plugin"></slide>
          <slide><img v-lazy="'/img/p/figmaplugins/populate3.jpg'" alt="Screenshot of the Populate plugin"></slide>
        </project-carousel>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Random Number Generator</h1>
          <p>Select text layers and replace them with randomly generated numbers, lightning fast. Replace existing numbers within a text layer, reuse a custom range, disable duplicates, and format long numbers with commas.</p>
          <br><p>Originally released August 2021</p>
          <br><p>Visit the <a href="https://www.figma.com/community/plugin/1009688420146523321/random-number-generator" target="_blank">plugin page</a>.</p>
        </project-text>

        <project-carousel
        size="75"
        :color="$store.state.activeProject.color"
        :autoplay="false">
          <slide><img v-lazy="'/img/p/figmaplugins/rng1.jpg'" alt="Screenshot of the Random Number Generator plugin"></slide>
          <slide><img v-lazy="'/img/p/figmaplugins/rng2.jpg'" alt="Screenshot of the Random Number Generator plugin"></slide>
          <slide><img v-lazy="'/img/p/figmaplugins/rng3.jpg'" alt="Screenshot of the Random Number Generator plugin"></slide>
        </project-carousel>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectText, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
